import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Keep Angular's default reuse behavior except for Create Workspace.
 * That route should always instantiate a fresh component.
 */
export class CreateWorkspaceRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {}

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futurePath = future.routeConfig?.path;
    const currentPath = curr.routeConfig?.path;
    if (futurePath === 'workspaces/create' || currentPath === 'workspaces/create') {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
